import { motion } from "framer-motion";
import { WHY } from "../../data/services";
import { Eyebrow, MaskedLines, EASE } from "../site/Reveal";

export const WhySection = () => (
  <section className="relative bg-[#070F1E] grain py-24 sm:py-36 overflow-hidden" data-testid="home-why">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-14">
      <div className="lg:col-span-5 lg:sticky lg:top-32 self-start">
        <Eyebrow dark>Why choose us</Eyebrow>
        <h2 className="mt-6 font-display text-[#F4EEE3] text-4xl sm:text-6xl leading-[0.98] tracking-tight">
          <MaskedLines inView delay={0} lines={["Bona fide.", <span className="italic text-[#E3C88A]">Unaffected.</span>, "Always on your side."]} />
        </h2>
      </div>
      <div className="lg:col-span-7">
        {WHY.map((w, i) => (
          <motion.div key={w.title} data-testid={`why-item-${i}`}
            initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 1, ease: EASE, delay: i * 0.1 }}
            className="group grid grid-cols-[auto_1fr] gap-6 sm:gap-10 border-t border-[#C5A059]/20 py-10 sm:py-14">
            <span className="font-display italic text-6xl sm:text-8xl leading-none text-transparent [-webkit-text-stroke:1px_#C5A059] transition-colors duration-500 group-hover:text-[#C5A059]">0{i + 1}</span>
            <div>
              <h3 className="font-display text-3xl sm:text-4xl text-[#F4EEE3]">{w.title}</h3>
              <p className="mt-4 text-base sm:text-lg text-[#C9C3B6] leading-relaxed max-w-lg">{w.text}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
